export const route = {
    params: {
        userId: 'userId',
    },
} as const;
